import React, { useMemo } from 'react';

import { Form, Table } from 'react-bootstrap';
import { createSelector } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store/rootReducer';

import { questionnaireAnswerUpdated } from '../../store/questionnaireSlice';
import { AppDispatch } from '../../store/store';
import { ApplicationQuestionnaireListAnswer } from '../../api/openapi';

interface Props {
  categoryId: string;
  subcategoryId: string | undefined;
}

const questionsSelector = () => {
  return createSelector(
    (state: RootState) => state.questionnaire.applicationQuestionnaire?.answers || [],
    (_: RootState, categorySubcategoryPair: [string, string | undefined]) => categorySubcategoryPair,
    (answers: Array<ApplicationQuestionnaireListAnswer>, pair: [string, string | undefined]) =>
      answers.filter((a) => {
        if (a.question.categoryId === pair[0]) {
          if (!a.question.subcategoryId && !pair[1]) {
            return true;
          }
          if (a.question.subcategoryId === pair[1]) {
            return true;
          }
        }

        return false;
      })
  );
};

const QuestionnaireQuestionsTable: React.FC<Props> = ({ categoryId, subcategoryId }: Props) => {
  const applicationQuestionnaire = useSelector((state: RootState) => state.questionnaire.applicationQuestionnaire);
  const questionnaireAnswers = useSelector((state: RootState) => state.questionnaire.questionnaireAnswers);
  const dispatch = useDispatch<AppDispatch>();

  const questionsSelectorMemo = useMemo(questionsSelector, []);
  const questions = useSelector((state: RootState) => questionsSelectorMemo(state, [categoryId, subcategoryId]));

  const handleChange = (id: string, answer: number) => {
    dispatch(
      questionnaireAnswerUpdated({
        id,
        answer,
      })
    );
  };

  const renderCheck = (id: string, value: number) => (
    <Form.Check
      className="mr-4"
      inline
      type="radio"
      label={`${value}`}
      name={`${value}`}
      id={`btn-${value}-${id}`}
      checked={questionnaireAnswers[id] === value}
      value={value}
      onChange={(e) => e.target.checked && handleChange(id, value)}
      disabled={applicationQuestionnaire?.status !== 'SENT' && applicationQuestionnaire?.status !== 'RETURNED'}
    />
  );

  return (
    <>
      <Table>
        <tbody>
          {questions.map((q) => (
            <tr key={q.id}>
              <td colSpan={8}>{q.question.question}</td>
              <td colSpan={4} style={{ textAlign: 'right' }}>
                <Form>
                  <Form.Group style={{ display: 'inline-flex' }}>
                    {renderCheck(q.id, 1)}
                    {renderCheck(q.id, 2)}
                    {renderCheck(q.id, 3)}
                    {renderCheck(q.id, 4)}
                  </Form.Group>
                </Form>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
};

export default QuestionnaireQuestionsTable;
